// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.promptWrapper--LdDAJ {
  grid-row: 2;
  grid-column: 2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  color: #1A202C;
}
.promptWrapper--LdDAJ .restartButton--a_iv3 {
  width: 200px;
  align-self: center;
  margin-bottom: 0.5rem;
}
.promptWrapper--LdDAJ .testQuestions--w4Gw5 {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  flex-direction: row;
  width: 100%;
  margin-bottom: 1rem;
  padding: 0;
}
.promptWrapper--LdDAJ .testQuestions--w4Gw5 li {
  flex: 1 1 calc(50% - 0.5rem);
  list-style: none;
  border: 2px solid #CBD5E0;
  border-radius: 0.25rem;
  padding: 0.5rem 1rem;
  box-sizing: border-box;
  cursor: pointer;
  align-items: center;
  display: flex;
}
.promptWrapper--LdDAJ .testQuestions--w4Gw5 li:hover {
  border-color: #495A7C;
}
.promptWrapper--LdDAJ .textAreaWrapper--AIpXp {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.promptWrapper--LdDAJ .textAreaWrapper--AIpXp textarea {
  font-family: Rubik, sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 150%;
  border-radius: 4px;
  border: var(--bo-ui-input-text-border, 2px solid #6B83A8);
  width: 100%;
  height: 60px;
  padding: 1rem 5.5rem 0.5rem 1rem;
  resize: none;
}
.promptWrapper--LdDAJ .textAreaWrapper--AIpXp textarea::-moz-placeholder {
  font-size: 1rem;
  font-weight: 400;
  color: #5A6F99;
}
.promptWrapper--LdDAJ .textAreaWrapper--AIpXp textarea::placeholder {
  font-size: 1rem;
  font-weight: 400;
  color: #5A6F99;
}
.promptWrapper--LdDAJ .textAreaWrapper--AIpXp textarea:hover,
.promptWrapper--LdDAJ .textAreaWrapper--AIpXp textarea:active,
.promptWrapper--LdDAJ .textAreaWrapper--AIpXp textarea:focus-visible {
  border-color: #495A7C;
}
.promptWrapper--LdDAJ .textAreaWrapper--AIpXp button {
  position: absolute;
  right: 0.5rem;
}
.promptWrapper--LdDAJ .errorWrapper--oWRvv {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin: 1rem 0 2rem;
}
.promptWrapper--LdDAJ .errorWrapper--oWRvv .errorMessage--vfcJ2 {
  color: red;
}
.expand--Prwzj {
  transition: 0.5s;
}
`, "",{"version":3,"sources":["webpack://./src/components/questionInput/style.module.less"],"names":[],"mappings":"AAOA;EACE,WAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;AANF;AADA;EAUI,YAAA;EACA,kBAAA;EACA,qBAAA;AANJ;AANA;EAgBI,aAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,UAAA;AAPJ;AAfA;EAyBM,4BAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,oBAAA;EACA,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;AAPN;AASM;EACE,qBAAA;AAPR;AA7BA;EA0CI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AAVJ;AAnCA;EAgDM,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yDAAA;EACA,WAAA;EACA,YAAA;EACA,gCAAA;EACA,YAAA;AAVN;AAYM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAVR;AAOM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAVR;AAaM;;;EAGE,qBAAA;AAXR;AAzDA;EAyEM,kBAAA;EACA,aAAA;AAbN;AA7DA;EA+EI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAfJ;AAnEA;EAqFM,UAAA;AAfN;AAoBA;EACE,gBAAA;AAlBF","sourcesContent":["@import \"~@boclips-ui/styles/src/colors\";\n\n@border: var(--bo-ui-input-text-border, 2px solid @gray-500);\n@radius: 0.25rem;\n@btn-color: #162237;\n@btn-color-light: #7290c4;\n\n.promptWrapper {\n  grid-row: 2;\n  grid-column: 2;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  position: relative;\n  color: @gray-900;\n\n  .restartButton {\n    width: 200px;\n    align-self: center;\n    margin-bottom: 0.5rem;\n  }\n\n  .testQuestions {\n    display: flex;\n    gap: 0.5rem;\n    flex-wrap: wrap;\n    flex-direction: row;\n    width: 100%;\n    margin-bottom: 1rem;\n    padding: 0;\n\n    li {\n      flex: 1 1 calc(50% - 0.5rem);\n      list-style: none;\n      border: 2px solid @gray-400;\n      border-radius: @radius;\n      padding: 0.5rem 1rem;\n      box-sizing: border-box;\n      cursor: pointer;\n      align-items: center;\n      display: flex;\n\n      &:hover {\n        border-color: @gray-700;\n      }\n    }\n  }\n\n  .textAreaWrapper {\n    position: relative;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n\n    textarea {\n      font-family: Rubik, sans-serif;\n      font-size: 1rem;\n      font-weight: 400;\n      line-height: 150%;\n      border-radius: 4px;\n      border: @border;\n      width: 100%;\n      height: 60px;\n      padding: 1rem 5.5rem 0.5rem 1rem;\n      resize: none;\n\n      &::placeholder {\n        font-size: 1rem;\n        font-weight: 400;\n        color: @gray-600;\n      }\n\n      &:hover,\n      &:active,\n      &:focus-visible {\n        border-color: @gray-700;\n      }\n    }\n\n    button {\n      position: absolute;\n      right: 0.5rem;\n    }\n  }\n\n  .errorWrapper {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    margin: 1rem 0 2rem;\n\n    .errorMessage {\n      color: red;\n    }\n  }\n}\n\n.expand {\n  transition: 0.5s;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"promptWrapper": `promptWrapper--LdDAJ`,
	"restartButton": `restartButton--a_iv3`,
	"testQuestions": `testQuestions--w4Gw5`,
	"textAreaWrapper": `textAreaWrapper--AIpXp`,
	"errorWrapper": `errorWrapper--oWRvv`,
	"errorMessage": `errorMessage--vfcJ2`,
	"expand": `expand--Prwzj`
};
export default ___CSS_LOADER_EXPORT___;
